module.exports = __webpack_public_path__ + "img/huxi.8f0e6ad1.png";